import React from "react";
import "../ModalMouqabale.styles.scss";
import { TMouqabalaStep } from "@/features/profile/types";
import { Button } from "@mui/material";
import { InlineIcon } from "@iconify/react";

interface MouqStep1Props {
  setStep: React.Dispatch<React.SetStateAction<TMouqabalaStep>>;
  close?: () => void;
}
const MouqStep1 = ({ setStep, close }: MouqStep1Props) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <div className="rules">
        <p className="rules__title">Comment se déroule une mouqabala ?</p>
        <div className="rules__item">
          <div className="number">
            <span>1</span>
          </div>
          <p className="text">
            {" "}
            La mouqabala est une rencontre formelle entre les prétendants
            généralement en présence de membres de la famille ou d'une tierce
            personne pour que les prétendant ne soit pas en isolement. Les
            pretendant discutent de divers aspects, y compris les antécédents
            familiaux, les valeurs, les attentes et la compatibilité pour le
            projet de mariage .
          </p>
        </div>
        <div className="rules__item">
          <div className="number">
            <span>2</span>
          </div>
          <p className="text">
            {" "}
            La mouqabala se déroule sur zoom ou Google meet avec une personne de
            l'équipe de zawaj sounnah qui entendra tout ce que vous dites mais
            ne vous verra pas. Elle dure 15 minutes, l'objectif étant de voir si
            vous vous plaisez physiquement avant d'engager vos familles.
          </p>
        </div>
        <div className="rules__item">
          <div className="number">
            <span>3</span>
          </div>
          <p className="text">
            {" "}
            A la fin de la mouqabala visio les prétendant auront le choix ou non
            de continuer et d'engager leurs familles respectives.
          </p>
        </div>
      </div>
      <div className="tarif-text">
        <InlineIcon icon="clarity:warning-solid" className="icon" />
        <p>
          Réserver une Mouqabala est payant à hauteur de 4€ pour 15min de
          discussion
        </p>
      </div>
      <div className="btn-layout">
        <Button
          variant="contained"
          className="btn-mouq"
          onClick={() => {
            setStep(2);
          }}
          endIcon={<InlineIcon icon="ic:outline-navigate-next" />}
          color="primary"
        >
          continuer
        </Button>
      </div>
    </div>
  );
};

export default MouqStep1;
